const _downloadFile = async (url: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.click();
  setTimeout(() => {
    a.remove();
  }, 100);
};

export const downloadFile = async (
  url: string,
  retries = 5,
  initialDelay = 1000,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      const attemptDownload = async (attempt: number): Promise<void> => {
        try {
          await _downloadFile(url);
          resolve();
        } catch (error) {
          if (attempt < retries) {
            const delay = initialDelay * Math.pow(2, attempt);
            console.log(`Download failed, retrying in ${delay}ms... (${attempt + 1}/${retries})`);
            setTimeout(() => attemptDownload(attempt + 1), delay);
          } else {
            throw error;
          }
        }
      };

      attemptDownload(0);
    } catch (error) {
      console.error('Error downloading file:', error);
      reject(error);
    }
  });
};
